let a = '';
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  a = 'isMobile';
} else {
  a = 'isPc';
}

const consts = {
  state: {
    useragent:a,
    info_materialId:'',
  },
  mutations: {
    UPDATEUSERAGENT: (state, data) => {
      state.useragent = data;
    },
    UPDATEINFO_MID: (state, data) => {
      state.info_materialId = data;
    },
  },
  actions: {
    updateUSERAGENT({ commit }, data) {
      commit("UPDATEUSERAGENT", data);
    },
    updateINFO_MID({ commit }, data) {
      commit("UPDATEINFO_MID", data);
    },
  },
  getters: {
    useragent: state => {
      return state.useragent;
    },
    info_materialId: state => {
      return state.info_materialId;
    },
  },
};
export default consts;
  


// WEBPACK FOOTER //
// ./src/store/mutations/consts.js